/** Created by azhou on 2019/3/20.*/
<template>
    <div>
      <public-title>提现申请</public-title>
      <div class="bg-white load-area">
        <search-con class="mop-none" :orderType="orderType" @getSearchCon="getSearchCon"/>
        <p v-if="AdminDataLists.total<=0" class="mt-3">当前没有数据</p>
        <div v-else>
        <!--采购商-->
            <ul class="list-head mt-3">
              <li  v-for="item in titleArrTravelList" :key="item" :class="item=='开户银行'? 'w-70' : 'w-50'" v-html="item"></li>
            </ul>
            <ul class="list-item" v-for="item in AdminDataLists.lists" :key="item.id">
            <li class="w-50 list-item-col flex-column breakword goHotelDetail" @click="goHotelDetail(item)">{{item.oid}}</li>
            <li class="w-50 list-item-col">{{item.travel_title}}</li>
            <li class="w-50 list-item-col">{{item.truename}}</li>
            <li class="w-70 bank_name">
              <div>开户银行：{{item.bank_name||'无'}}</div>
              <div>支行名称：{{item.branch||'无'}}</div>
              <div>银行卡号：{{item.bank_card||'无'}}</div>
            </li>
            <li class="w-50 list-item-col">{{item.price | formatMoney}}</li>
            <li class="w-50 list-item-col">{{item.price_pay/100 | formatMoney}}</li>
            <li class="w-50 list-item-col red">{{item.profit/100 | formatMoney}}</li>
            <template v-for="arr in tabArr">
              <li class="w-50 list-item-col"  v-if="arr.id==item.pay_flag_travel " :key="arr.id" :class="arr.value" >{{arr.label}}</li>
            </template>
            <li class="w-50 list-item-col-end flex-wrap">
                    <el-button  size="mini"  type="success" @click="financeprice(item)">提交财务</el-button>
                    <el-button  size="mini"  @click="handleEdit(item)">驳回申请</el-button>
            </li>
            </ul>
          <el-pagination background layout="prev, pager, next" class="mt-4"
                         :total="AdminDataLists.total" :current-page="Number(queryCon.page)"
                         @current-change="$GFUN.pageChange"/>
            
        </div>
      </div>
      <el-dialog title="提交财务" :visible.sync="finance" width="340px" class="paymentist" :close-on-click-modal="false" top="16%">
            <commission v-if="finance" :remark="remark" @finance="finance=!finance" :oid="pay_id" :modify="modify" :price_pay="price_pay" @submitFinance="submitFinance"></commission>
      </el-dialog>
    </div>
</template>

<script>
  import commission from './Subassembly/commission.vue'
  import SearchCon from './Subassembly/SearchCon.vue'
  import { mapGetters, mapActions,mapState } from 'vuex'
import Temp from './FinancialStats/EchartStat/temp.vue'
  export default {
    name: 'WithdrawApply',
    components:{SearchCon,commission, Temp},
    computed: {
      ...mapState(['AdminDataLists','userLoginMessage']),
      ...mapGetters(['storeInfo','isAdmin']),
      queryCon() { return this.$route.query },
            //搜索条件-开始时间
      startTime() { return this.timestamp ? this.timestamp[0] / 1000 : ''; },
      //搜索条件-结束时间
      endTime() { return this.timestamp ? this.timestamp[1] / 1000 + 86399 : ''; },
      timeChoose() {
        let arr =  [
          {name:`按时间段`,value:'timeFrame'},
          {name:`按日期`,value:'timeArr'},
        ];
        return arr
      },
    },
    created() { this.getDataLists();},
    data() {
      return {
        cardItem:{},                      //选择订单
        finance:false,                    //提交财务弹窗
        activeName: '2',
        tabArr:[
          {label:'未处理',id:'8',value:'red'},
          {label:'已通过',id:'1',value:'green'},
          {label:'未通过',id:'9',value:'text-info'},
        ],
        titleArrTravelList:['订单号','所属采购商','企业名称/个人姓名','开户银行','总支付(元)','总应收(元)','利润(元)','状态','操作'],
        Formdata:{},
        orderType:2,
      }
    },
    watch: {
        //接收到消息更新列表
        newMessageInform (newVal) {
            if(newVal.type==105){
                this.getDataLists(1);
            }
        },
    },
    methods:{
      ...mapActions(['getAdminDataLists','adminSubmitFinance','adminSubmitRefuse']),
      //点击切换tab
      handleClick(){
        this.getDataLists();
      },
            /*根据条件搜索订单*/
      getSearchCon(con) {
        this.Formdata = con;
        this.getDataLists(con);
      },
      //获取提现列表
      getDataLists(con) {
        let data = {
          ...this.queryCon,
          ...this.Formdata,
        }
        if (con) data.page = 1
        this.getAdminDataLists({
          type:'withdrawalTravelList',
          data
        });
      },
      /**
       * 管理员提交财务
       */
      submitFinance(ruleForm){
        this.finance=!this.finance
        this.adminSubmitFinance({
          type:2,
          data:ruleForm,
          successFun: () => {
              this._alert('已提交财务，可在待打款列表中查看');
              this.getDataLists();
          }
        });
      },
      /**
       * 驳回采购商申请
       */
      handleEdit(res){
        let data={
          oid:res.oid
        }
        this.adminSubmitRefuse({
          data,
          successFun: () => {
              this._alert('操作成功');
              this.getDataLists();
          }
        });
      },
      /**
       * 手续费最大值
      */
        financeprice(res){
          this.finance=true;
          this.price_pay=res.profit/100;
          this.modify=res.charge/100;
          this.pay_id = res.oid;
          this.remark=res.remark;
        },
      //订单详情页
      goHotelDetail (e) {
            let cardItem=e;
            console.log(this.storeInfo)
            let routeUrl = this.$router.resolve({
                name: 'OrderDetail',
                query: {
                    orderType: 3,
                    orderId: cardItem.oid,
                    storeId: this.storeInfo.type == 2 ? cardItem.main_id : (cardItem.store_id || cardItem.appoint),
                    status: cardItem.status,
                }
            });
            window.open(routeUrl.href, '_blank');
      },
    }
  }
</script>

<style lang="scss" scoped>
  .el-select{
    float: left;
    margin-right: 30px
  }
  .textal{
    width: 56px!important;
    display: inline-block;
    text-align-last: justify;
  }
  .mr-auto{
    span{
      display: inline-block;
      width: 150px;
      text-align: right;
      vertical-align: text-bottom
    }
    .vt{
      vertical-align: top
    }
  }
  .vm{
    margin-left: 2px;
    vertical-align: middle;
    cursor: pointer;
  }
  .goHotelDetail{
    cursor: pointer;

  }
 .goHotelDetail:hover{
    color: var(--smtc-color-primary);
  }
  .bank_name{
    text-align: left;
    border-right: 1px #eee solid;
    padding: 10px;
  }
</style>
